module.exports = __webpack_public_path__ + "img/x-white.6ca35154.svg";